export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const DRAFTS_LOADING = "DRAFTS_LOADING";
export const DRAFTS_LOADING_DISABLE = "DRAFTS_LOADING_DISABLE";

export const FETCH_DRAFT = "FETCH_DRAFT";
export const FETCH_DRAFT_SUCCESS = "FETCH_DRAFT_SUCCESS";

export const FETCH_DRAFTS_SUCCESS = "FETCH_DRAFTS_SUCCESS";
export const CLEAR_DRAFTS_SUCCESS = "CLEAR_DRAFTS_SUCCESS";
export const SET_DRAFT_STATUS_SUCCESS = "SET_DRAFT_STATUS_SUCCESS";
export const SET_DRAFT_DETAIL_ROW_SUCCESS = "SET_DRAFT_DETAIL_ROW_SUCCESS";

export const DRAFT_WORKER_DELETE = "DRAFT_WORKER_DELETE";
export const DRAFT_WORKER_INSERT = "DRAFT_WORKER_INSERT";
export const DRAFT_WORKER_UPDATE = "DRAFT_WORKER_UPDATE";
export const DRAFT_WORKER_BULK_REPLACE = "DRAFT_WORKER_BULK_REPLACE";
export const DRAFT_FIND_MISSING_WORKERS = "DRAFT_FIND_MISSING_WORKERS";

export const FETCH_SCHEDULE_REPORT_FIELDS = "FETCH_SCHEDULE_REPORT_FIELDS";
export const SCHEDULE_REPORT_FIELDS_LOADING = "SCHEDULE_REPORT_FIELDS_LOADING";

export const DELETE_DRAFT = "DELETE_DRAFT";

export const ADD_STORES_TO_DRAFT = "ADD_STORES_TO_DRAFT";
export const DELETE_STORE_FROM_DRAFT = "DELETE_STORE_FROM_DRAFT";

export const ADD_JOBS_TO_DRAFT = "ADD_JOBS_TO_DRAFT";
export const DELETE_JOB_FROM_DRAFT = "DELETE_JOB_FROM_DRAFT";

export const DELETE_DATE_FROM_JOB_PRODUCT = "DELETE_DATE_FROM_JOB_PRODUCT";

export const FETCH_DRAFTS_DETAILS = "FETCH_DRAFTS_DETAILS";
export const FETCH_DRAFTS_DETAILS_SUCCESS = "FETCH_DRAFTS_DETAILS_SUCCESS";
export const FETCH_ONLY_DRAFTS_DETAILS_SUCCESS = "FETCH_ONLY_DRAFTS_DETAILS_SUCCESS";

export const SYSTEM_LISTS_LOADING = "COMMODITIES_LOADING";
export const SYSTEM_LISTS_ERRORS = "COMMODITIES_ERRORS";
export const SYSTEM_LISTS_GET_EMPLOYMENT_TYPES = "SYSTEM_LISTS_GET_EMPLOYMENT_TYPES";
export const SYSTEM_LISTS_GET_EMPLOYMENT_STATUS = "SYSTEM_LISTS_GET_EMPLOYMENT_STATUS";
export const SYSTEM_LISTS_GET_LANGUAGES = "SYSTEM_LISTS_GET_LANGUAGES";
export const SYSTEM_LISTS_GET_APPLIED_FOR = "SYSTEM_LISTS_GET_APPLIED_FOR";
export const SYSTEM_LISTS_GET_WORK_HOURS_AVAILABILITY = "SYSTEM_LISTS_GET_WORK_HOURS_AVAILABILITY";
export const SYSTEM_LISTS_GET_TRAVEL_TYPES = "SYSTEM_LISTS_GET_TRAVEL_TYPES";
export const FETCH_COMMODITIES_SUCCESS = "FETCH_COMMODITIES_SUCCESS";

export const EMPLOYEE_LOADING = "EMPLOYEE_LOADING";
export const EMPLOYEE_ERRORS = "EMPLOYEE_ERRORS";
export const FETCH_SUPERVISORS = "FETCH_SUPERVISORS";
export const FETCH_ADMINISTRATORS_SUCCESS = "FETCH_ADMINISTRATORS_SUCCESS";
export const FETCH_HR_SUCCESS = "FETCH_HR_SUCCESS";
export const FETCH_SUPERVISORS_SUCCESS = "FETCH_SUPERVISORS_SUCCESS";
export const FETCH_MERCHANDISERS = "FETCH_MERCHANDISERS";
export const FETCH_MERCHANDISERS_SUCCESS = "FETCH_MERCHANDISERS_SUCCESS";
export const FETCH_ACCOUNT_MANAGERS_SUCCESS = "FETCH_ACCOUNT_MANAGERS_SUCCESS";
export const FETCH_HELPERS_SUCCESS = "FETCH_HELPERS_SUCCESS";

export const FETCH_EMPLOYEES = "FETCH_EMPLOYEES";
export const FETCH_EMPLOYEES_SUCCESS = "FETCH_EMPLOYEES_SUCCESS";

export const FETCH_EMPLOYEE_SUCCESS = "FETCH_EMPLOYEE_SUCCESS";
export const FETCH_EMPLOYEE_AVAILABILITY = "FETCH_EMPLOYEE_AVAILABILITY";
export const FETCH_EMPLOYEE_AVAILABILITY_SUCCESS = "FETCH_EMPLOYEE_AVAILABILITY_SUCCESS";
export const FETCH_EMPLOYEE_COMMENTS_SUCCESS = "FETCH_EMPLOYEE_COMMENTS_SUCCESS";
export const FETCH_EMPLOYEE_SCHEDULED_WORK = "FETCH_EMPLOYEE_SCHEDULED_WORK";
export const FETCH_EMPLOYEE_SCHEDULED_WORK_SUCCESS = "FETCH_EMPLOYEE_SCHEDULED_WORK_SUCCESS";
export const REMOVE_SINGLE_EMPLOYEE = "REMOVE_SINGLE_EMPLOYEE";

export const FETCH_SERVICE_TYPES_ERROR = "FETCH_SERVICE_TYPES_ERROR";
export const FETCH_SERVICE_TYPES_SUCCESS = "FETCH_SERVICE_TYPES_SUCCESS";

export const ORDERS_LOADING = "ORDERS_LOADING";
export const FETCH_ORDERS = "FETCH_ORDERS";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";

export const FETCH_ORDER_HEADER = "FETCH_ORDER_HEADER";
export const FETCH_ORDER_HEADER_SUCCESS = "FETCH_ORDER_HEADER_SUCCESS";
export const FETCH_ORDER_DETAIL = "FETCH_ORDER_DETAIL";
export const FETCH_ORDER_DETAIL_SUCCESS = "FETCH_ORDER_DETAIL_SUCCESS";
export const FETCH_PLANOGRAM_DATA = "FETCH_PLANOGRAM_DATA";
export const FETCH_PLANOGRAM_DATA_SUCCESS = "FETCH_PLANOGRAM_DATA_SUCCESS";
export const SUBMIT_ORDER = "SUBMIT_ORDER";
export const SUBMIT_ORDER_SUCCESS = "SUBMIT_ORDER_SUCCESS";
export const UN_SUBMIT_ORDER = "UN_SUBMIT_ORDER";
export const UN_SUBMIT_ORDER_SUCCESS = "UN_SUBMIT_ORDER_SUCCESS";
export const ADD_OR_UPDATE_ORDER = "ADD_OR_UPDATE_ORDER";
export const ADD_OR_UPDATE_ORDER_SUCCESS = "ADD_OR_UPDATE_ORDER_SUCCESS";
export const INVOICE_REQUEST_LOADING = "INVOICE_REQUEST_LOADING";

// Duplication action types
export const GET_APPLICANT_DUPLICATION_INFO = "GET_APPLICANT_DUPLICATION_INFO";
export const DUPLICATION_LOADING = "DUPLICATION_LOADING";
export const DUPLICATION_ERROR = "DUPLICATION_ERROR";